const initialState = {
  events: null,
};

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_EVENTS":
      return {
        ...state,
        events: action.data,
      };
    case "ADD_EVENT":
      return {
        ...state,
      };
    case "DELETE_EVENT_BY_ADMIN":
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default eventReducer;
